import React, {Fragment, useEffect, useState} from "react";

// reactstrap components
import {
    Button,
    Card,
    CardFooter,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText, Modal,
    Row,
    Table, UncontrolledTooltip,
} from "reactstrap";
// layout for this page
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import PaginationWrapper from "../components/pagination";
import {clickImg, numberWithCommas, paginate, telWithCommas} from "../../../utils";
import useHistoryState from "../../../common/useHistoryState";
import moment from "moment";
import {useHistory} from "react-router";
import ploggingService from "./service/plogging.service";
import centerService from "../center/service/center.service";
import {Link} from "react-router-dom";
import storeService from "../store/service/store.service";
import ReactDatetime from "react-datetime";
import classnames from "classnames";
import AuthService from "../auth/auth.service";
import sharingPloggingService from "./service/sharingPlogging.service";
import dayjs from "dayjs";
import payService from "./service/pay.service";

function SharedPloggingPaymentMgmt() {
    const user = typeof window !== 'undefined' ? AuthService.getCurrentUser() : null;
    const centerPlogging = JSON.parse(localStorage.getItem('user'))?.centerPlogging;
    const companyPlogging = JSON.parse(localStorage.getItem('user'))?.companyPlogging;
    const history = useHistory();
    const [finalDate, setFinalDate] = useState('');
    const [pageActive, setPageActive] = useHistoryState(1, 'pageActive');
    const [pageCount, setPageCount] = useHistoryState(1, 'pageCount');
    const [data, setData] = useHistoryState([], 'data');
    const [searchCurrent, setSearchCurrent] = useHistoryState(false, 'searchCurrent');
    const [search, setSearch] = useHistoryState('', 'search');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [amountSum, setAmountSum] = useState(0);
    const [centerAmountSum, setCenterAmountSum] = useState(0);

    const render = () => {
        const revised = startDate ? dayjs(startDate).format('YYYY-MM') : undefined;
        let option = {date: revised};

        if (pageCount) {
            option.page = pageActive;
        } else {
            option.page = 1;
        }

        console.log(pageCount);
        console.log(option);

        payService.list(option)
            .then((res) => {
                if (res.code === 200) {
                    console.log(res);
                    setPageCount(res.list.count);
                    setData(res.list.rows);
                }
            });

        payService.list({ date: revised }).then((res) => {
            // [].reduce(res => res.amount + );
            // console.log(res.list.reduce((element) => ));
        })
    };

    useEffect(() => {
        render();
    }, [pageActive, pageCount, search, startDate, endDate]);

    const remove = (id) => {
        if (window.confirm('삭제하시겠습니까?')) {
            ploggingService.remove(Number(id))
                .then(res => res.data)
                .then(res => {
                    alert('삭제되었습니다.')
                    render();
                })
        }
    };

    const handleReactDatetimeChange = (who, date) => {
        if (
            startDate &&
            who === "endDate" &&
            new Date(startDate) > new Date(date.format('YYYY-MM-DD'))
        ) {
            setStartDate(date.format('YYYY-MM-DD'));
            setEndDate(date.format('YYYY-MM-DD'));
        } else if (
            endDate &&
            who === "startDate" &&
            new Date(endDate) < new Date(date.format('YYYY-MM-DD'))
        ) {
            setStartDate(date.format('YYYY-MM-DD'));
            setEndDate(date.format('YYYY-MM-DD'));
        } else {
            if (who === "startDate") {
                setStartDate(date.format('YYYY-MM-DD'));
            } else {
                setEndDate(date.format('YYYY-MM-DD'));
            }
        }
    };

    const getClassNameReactDatetimeDays = (date) => {
        if (startDate && endDate) {
        }
        if (startDate && endDate && startDate !== endDate) {
            if (
                new Date(endDate) > new Date(date.format('YYYY-MM-DD')) &&
                new Date(startDate) < new Date(date.format('YYYY-MM-DD'))
            ) {
                return " middle-date";
            }
            if (endDate === date.format('YYYY-MM-DD')) {
                return " end-date";
            }
            if (startDate === date.format('YYYY-MM-DD')) {
                return " start-date";
            }
        }
        return "";
    };

    const statusChange = async (id, check) => {
        await centerService.update(id, {isPlogging: check});
        render();
    }

    const changeCenter = async (i, id) => {
        await centerService.update(id, {endDate: data[i].endDate});
        render();
        alert('수정되었습니다')
    }

    return (
        <>
            <>
                <>
                    <SimpleHeader name="Tables" parentName="Tables"/>
                    <Container className="mt--6" fluid>
                        <Row>
                            <div className="col">
                                <Card>
                                    <CardHeader className="border-0">
                                        <Row className="py-3">
                                            <Col xs="11">
                                                <Form>
                                                    <Row>
                                                            <Col md="auto">
                                                                <label className=" form-control-label">
                                                                    날짜 조회
                                                                </label>
                                                                <Row style={{ gap: 16 }}>
                                                                    <ReactDatetime
                                                                        inputProps={{
                                                                            placeholder: "",
                                                                        }}
                                                                        value={startDate}
                                                                        locale={'ko'}
                                                                        timeFormat={false}
                                                                        dateFormat={'YYYY-MM'}
                                                                        onChange={(e) =>
                                                                            handleReactDatetimeChange("startDate", e)
                                                                        }
                                                                        renderDay={(props, currentDate, selectedDate) => {
                                                                            let classes = props.className;
                                                                            classes += getClassNameReactDatetimeDays(
                                                                                currentDate
                                                                            );
                                                                            return (
                                                                                <td {...props} className={classes}>
                                                                                    {currentDate.date()}
                                                                                </td>
                                                                            );
                                                                        }}
                                                                    />
                                                                    <Button
                                                                        className="btn-default"
                                                                        onClick={() => {
                                                                            setStartDate('')
                                                                            setEndDate('')
                                                                            setSearch("")
                                                                        }}
                                                                    >
                                                                        <span className="btn-inner-text">초기화</span>
                                                                    </Button>
                                                                </Row>
                                                            </Col>
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs="6">
                                                <h3 className="mt-2">나눔플로깅 결제관리</h3>
                                            </Col>
                                            {/*{user?.role === 'center' ? null : (*/}
                                            {/*  <Col className="text-right">*/}
                                            {/*      <Button color="default" onClick={(e) => history.push('/admin/donationForm')}>*/}
                                            {/*          등록하기*/}
                                            {/*      </Button>*/}
                                            {/*  </Col>*/}
                                            {/*)}*/}
                                        </Row>
                                    </CardHeader>

                                    <Table className="align-items-center table-flush" responsive striped>
                                        <thead className="thead-light">
                                        <tr>
                                            <th className="text-center" style={{width: '10%'}}>결제일</th>
                                            <th className="text-center" style={{width: '10%'}}>선택 단체</th>
                                            <th className="text-center" style={{width: '10%'}}>이름</th>
                                            <th className="text-center" style={{width: '10%'}}>연락처</th>
                                            <th className="text-center" style={{width: '10%'}}>결제 금액</th>
                                            <th className="text-center" style={{width: '10%'}}>기부 전달 금액</th>
                                            <th className="text-center" style={{width: '10%'}}>활동 잔여일</th>
                                            <th className="text-center" style={{width: '25%'}}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {data?.map((item, i) => {
                                            return [
                                                <Fragment key={i}>
                                                    <tr>
                                                        <td className="text-center">
                                                            {item.createdAt}
                                                        </td>
                                                        <td className="text-center">
                                                            {item.center}
                                                        </td>
                                                        <td className="text-center">
                                                            {item.user.name}
                                                        </td>
                                                        <td className="text-center">
                                                            {telWithCommas(item.user.tel)}
                                                        </td>
                                                        <td className="text-center">
                                                            {numberWithCommas(item.amount)}
                                                        </td>
                                                        <td className="text-center">
                                                            {numberWithCommas(item.centerAmount)}
                                                        </td>
                                                        <td className="text-center">
                                                            {item.remainingDays}
                                                        </td>
                                                    </tr>
                                                </Fragment>
                                            ];
                                        })}
                                        </tbody>
                                    </Table>

                                    <CardFooter className="py-4">
                                        <PaginationWrapper
                                            isActive={pageActive}
                                            pageNumber={pageCount}
                                            callback={(page) => setPageActive(page)}
                                            itemPerPage={10}
                                        />
                                    </CardFooter>
                                </Card>
                            </div>
                        </Row>
                    </Container>
                </>
            </>

        </>
    );
}

export default SharedPloggingPaymentMgmt;
